/// <reference types="../../vite-env.d.ts" />
import './css/_bundle.scss';

import { createApp, defineComponent } from 'vue';
import { getElementProps, getScriptProps, loadInitializers } from './js-utils/_shared/initializers-loader';

if (!(window as any).frontVueInit) {
    // prevent processing twice (?)
    (window as any).frontVueInit = true;

    // Dynamically import and mount initializers
    loadInitializers();

    // Eagerly import all visual Vue components
    const modules = import.meta.glob('./vue-components/**/*.vue', { eager: true });

    // Dynamically mount visual Vue components required in this page
    const elements = document.querySelectorAll(
        'template[data-load-component],script[data-load-component]',
    ) as NodeListOf<HTMLElement>;

    elements.forEach((elem) => {
        // get the component name from the data attribute
        const componentName = elem.getAttribute('data-load-component')!;

        // get the component properties from the element attributes or script content, depending on the tag type
        const props = elem.tagName === 'SCRIPT' ? getScriptProps(elem) : getElementProps(elem);

        // insert a target element after the script tag
        const targetElem = elem.insertAdjacentElement('afterend', document.createElement('div')) as HTMLElement;

        // get the target component
        const module = (modules[`./vue-components/${componentName}.vue`] ||
            modules[`./vue-components/_shared/${componentName}.vue`] ||
            modules[`./vue-components/_shared1/${componentName}.vue`]) as ReturnType<typeof defineComponent>;

        // mount the target component
        if (module) {
            elem.remove(); // remove the original element after extracting props and before mounting the component
            props._rootElement = targetElem; // pass the target element as a prop to the component
            const app = createApp(module.default, props);
            app.mount(targetElem);
        }
    });
}
